import { Link } from "react-router-dom";
import '../Jugadores.css'
import Card from "../Card.js";
import data from '../datospele.json';
import LazyLoad from 'react-lazyload';
import { useState, useEffect } from "react";

function Titulo() {
  useEffect(() => {
    document.title = 'Pelé';
  }, []);
}

function MyComponent() {  
    const uniqueEquipos = [...new Set(data.map(item => item.Equipo))];
    const [selectedEquipo, setSelectedEquipo] = useState('0');

    const uniqueRivales = [...new Set(data.map(item => item.Rival))];
    const [selectedRival, setSelectedRival] = useState('0');

    const uniqueTemporadas = [...new Set(data.map(item => item.Temporada))];
    const [selectedTemporada, setSelectedTemporada] = useState('0');

    const uniqueCompeticiones = [...new Set(data.map(item => item.Competicion))];
    const [selectedCompeticion, setSelectedCompeticion] = useState('0');

    const uniqueVideos = [...new Set(data.map(item => item.Video))];
    const [selectedVideo, setSelectedVideo] = useState('0');
  
    // Función para filtrar los datos según el equipo seleccionado
    const filteredData = data.filter(item => {
        return (
          (selectedEquipo === '0' || item.Equipo === selectedEquipo) &&
          (selectedRival === '0' || item.Rival === selectedRival) &&
          (selectedTemporada === '0' || item.Temporada === selectedTemporada) &&
          (selectedCompeticion === '0' || item.Competicion === selectedCompeticion) &&
          (selectedVideo === '0' || item.Video !== "")
        );
      });
  
    // Función para manejar el cambio en el select
    const handleSelectChange = event => {
        const { name, value } = event.target;
        
        if (name === 'equipo') {
          setSelectedEquipo(event.target.value);
        } else if (name === 'rival') {
          setSelectedRival(event.target.value);
        } else if (name === 'temporada') {
            setSelectedTemporada(event.target.value);
        } else if (name === 'competicion') {
            setSelectedCompeticion(event.target.value);
        } else if (name === 'video') {
            setSelectedVideo(event.target.value);
        }
      };
  
    // Función para mostrar todos los equipos nuevamente
    const resetFilters = () => {
      setSelectedEquipo('0');
      setSelectedRival('0');
      setSelectedTemporada('0');
      setSelectedCompeticion('0');
      setSelectedVideo('0');
    };
  
    return (
      <>
      <div className="selectcontainer">
            <select
        className="selectequipos"
        name="equipo"
        value={selectedEquipo}
        onChange={handleSelectChange}
        >
        <option value="0">Elegir equipo</option>
        {uniqueEquipos.map((equipo, index) => (
          <option key={index} value={equipo}>
            {equipo}
          </option>
        ))}
        </select>
  
        <select
        className="selectrivales"
        name="rival"
        value={selectedRival}
        onChange={handleSelectChange}
        >
        <option value="0">Elegir rival</option>
        {uniqueRivales.sort().map((rival, index) => (
          <option key={index} value={rival}>
            {rival}
          </option>
        ))}
        </select>
  
        <select
        className="selecttemporadas"
        name="temporada"
        value={selectedTemporada}
        onChange={handleSelectChange}
        >
        <option value="0">Elegir temporada</option>
        {uniqueTemporadas.map((temporada, index) => (
          <option key={index} value={temporada}>
            {temporada}
          </option>
        ))}
        </select>
  
        <select
        className="selectcompeticiones"
        name="competicion"
        value={selectedCompeticion}
        onChange={handleSelectChange}
        >
        <option value="0">Elegir competición</option>
        {uniqueCompeticiones.map((competicion, index) => (
          <option key={index} value={competicion}>
            {competicion}
          </option>
        ))}
        </select>
            <br></br>
            <select
        className="selectvideos"
        name="video"
        value={selectedVideo}
        onChange={handleSelectChange}
        >
        <option value="0">Incluir partidos sin video</option>
        <option value="1">Solo partidos con video</option>
        </select>
        <button className="boton" onClick={resetFilters}>Restablecer</button>
      </div>
  
        {filteredData.map((item, index) => (
          <LazyLoad key={index} height={200} offset={100} once>
            <Card
              equipo={item.Equipo}
              logoequipo={item["Logo Equipo"]}
              rival={item.Rival}
              fecha={item.Fecha}
              temporada={item.Temporada}
              competicion={item.Competicion}
              minutos={item.Minutos}
              gol={item.Goles}
              asistencias={item.Asistencias}
              video={item.Video ? item.Video : null}
            />
          </LazyLoad>
        ))}
      </>
    );
  }

function Pele()
{
    return(
      <>
      <Titulo />
    <section className="main">
        <img className="banner" src='https://a.espncdn.com/photo/2018/0407/r353034_1296x729_16-9.jpg'></img>
        <div className="Nombre">PELÉ</div>
        <div className="Container">
            <MyComponent />

        </div>
    </section>
    </>
    )
}

export default Pele;